module.exports = __webpack_public_path__ + "media/assets/faria_products/OSCAPP-75d7339b830cfac57b2709d3dfc0b46d1100a5112ee9f0962c39215c49a9189d.png";